module.exports = __webpack_public_path__ + "img/4.01484b33.jpg";